import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class FacilityExtrastockOffersApi extends Api {
  constructor() {
    super('facility/extrastock_offers/');
  }
  approve(id, data) {
    return this.buildQuery(
      'put',
      {
        data,
      },
      `${id}`,
    );
  }
  getExtrastocks(params) {
    return this.buildQuery(
      'get',
      {
        params,
      },
      'extrastocks',
    );
  }

  createOffer(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }

  updateOffer(id, data) {
    return this.buildQuery(
      'put',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      id,
    );
  }

  deleteFile(id, fileId) {
    return this.buildQuery(
      'delete',
      {
        data: {
          ids: fileId,
        },
      },
      `${id}/remove_attachments`,
    );
  }
}

export default FacilityExtrastockOffersApi;
